<template>
  <div class="layout__content text-white text-start" style="font-size: calc(1rem + 0.2vw);">
        <ul>
          <li>Можно мыть в посудомоечной машине.</li>
          <li>Не остужать искусственно.</li>
          <li>Не использовать в микроволновых печах.</li>
          <li>Не использовать агрессивные химические средства.</li>
        </ul>
    <p> Внимание! Ростер для перепёлок запатентован и охраняется законом.</p>
    </div>
</template>
<style scoped lang="scss">

</style>